import PaymentMethod from './PaymentMethod';
import {AdyenCheckout, Card} from '@adyen/adyen-web';

import $Form from '../../common/forms';

export default class AdyenTokenizeCardPaymentMethod extends PaymentMethod {
  constructor(option, form, paymentPage) {
    super(option, form, paymentPage);

    this.sessionId = $('meta[name=AdyenTokenizeSessionId]').attr('content');
    this.sessionData = $('meta[name=AdyenTokenizeSessionData]').attr('content');
    this.clientKey = $('meta[name=AdyenClientKey]').attr('content');
    this.environment = $('meta[name=AdyenEnvironment]').attr('content');
  }

  async bindFormMethods(paymentPage) {
    super.bindFormMethods(paymentPage);

    const checkout = await AdyenCheckout(this.checkoutConfiguration);
    new Card(checkout, this.cardConfiguration).mount('#adyen-card-component');
  }

  get cardConfiguration() {
    return {
      hasHolderName: true,
      holderNameRequired: true,
      positionHolderNameOnTop: true,
      placeholders: {
        cardNumber: 'e.g. 1234 1234 1234 1234',
        expiryDate: 'MM / YY',
        securityCodeThreeDigits: 'CVC',
        holderName: 'e.g. Mr John Smith',
      },
    };
  }

  get checkoutConfiguration() {
    return {
      session: {
        id: this.sessionId,
        sessionData: this.sessionData,
      },
      environment: this.environment,
      locale: 'en-US',
      countryCode: 'GB',
      translations: {
        'en-US': {
          'payButton.saveDetails': this.form.data().cta,
        },
      },
      clientKey: this.clientKey,
      onPaymentCompleted: this.onPaymentCompleted.bind(this),
      onPaymentFailed: this.onPaymentFailed.bind(this),
      onError: this.onError.bind(this),
    };
  }

  onPaymentCompleted(result, component) {
    fetch('/events/log', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({event: 'adyen_card_payment_completed', data: {result: result.resultCode}}),
    });
    this.form.submit();
  }

  onPaymentFailed(result, component) {
    $Form.showGeneralError(this.form, 'adyen-card', 'Payment failed. If the problem persists, contact support.');
    component.setStatus('ready');

    fetch('/events/log', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({event: 'adyen_card_payment_failed', data: {result: result}}),
    });
  }

  onError(error, component) {
    component.setStatus('ready');
    $Form.showGeneralError(this.form, 'adyen-card', 'An error occurred. If the problem persists, contact support.');

    fetch('/events/log', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({event: 'adyen_card_payment_error', data: {error: error}}),
    });
  }

  async isAvailable() {
    return true;
  }
}
